import React from 'react'
import { PointViewModel } from './PointViewModel';
import { NavBarComponente } from '../../Components/NavBarComponente';
import { Container, Row, Image, Col, Form, Button } from 'react-bootstrap';
import { Marker } from 'leaflet';
import fechar from '../../Imagens/close-24.png';
import salvar from '../../Imagens/save-16.png';

import "../../Estilo/Form.css";
import Select from 'react-select';
import { FormEvent } from '../../ScreenGeneric/Models/FormEvent';
import { ToastContainer, toast } from 'react-toastify';
import { LoaderComponente } from "../../Components/LoaderComponente";
import { MapaComponente } from '../../Components/MapaComponente';
import { AddressViewModel } from '../Address/AddressViewModel';

interface MyProps {
    navigation: any
    delegate: PointViewControllerDelegate
    viewModel: PointViewModel
    idPrimary: number
    latitude?: string
    longitude?: string
}

export interface PointViewControllerDelegate {
    tapDimiss(navigation: any): void
    tapProperty(navigation: any, sgeppontos: number, pointType: string): void
}

export class PointViewController extends React.Component<MyProps> {

    private formEvent: FormEvent
    private marker: any
    private addressViewModel: AddressViewModel
    state = {
        isLoading: false,
        json: {
            latitude: -30.1087957,
            longitude: -51.3172251
        },
        district: [],
        prefix: '',
        layers: Array<any>(),
        pointType: Array<any>(),
        immobileSituation: Array<any>(),
        source: Array<any>(),
        tiposPonto: Array<any>()
    }

    constructor(props: any) {
        super(props)
        this.formEvent = new FormEvent(this)
        this.addressViewModel = new AddressViewModel();
    }

    componentDidMount() {
        this.loadPointType()
        this.loadSource()
        this.loadImmobileSituation()
        this.loadLayers()
        this.loadPointTypes()
        this.loadDistrict()

        if (this.props.latitude !== undefined && this.props.longitude !== undefined) {
            this.setLatLng(this.props.latitude, this.props.longitude)
            return
        }

        if (this.props.idPrimary > 0) {
            this.loadStruct()
        }
    }

    render() {
        var json = this.state.json as any
        return (
            <div>
                <NavBarComponente propNav={this.props.navigation} />
                <div>
                    <Container fluid={true}>
                        <Row>
                            <Col>
                                <div className="title">
                                    <h3>Ponto</h3>
                                </div>
                                <div className="buttonClose">
                                    <Image className="imageClose"
                                        onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)}
                                        src={fechar} />
                                </div>
                            </Col>
                        </Row>
                        <Form className="containerForm">
                            <Row>
                                <Col lg="4" xs="12" className="bottom10 hide">
                                    <Form.Label>Sequencial</Form.Label>
                                    <Form.Control
                                        id="sshape"
                                        defaultValue={json['sshape'] ? json['sshape'] : ''}
                                        onChange={(e: any) => this.formEvent.onChange("inteiro", e.target)}
                                    />
                                </Col>
                                <Col lg="4" xs="12">
                                    <Row>
                                        <Col xs="12" className="bottom10">
                                            <Form.Label>Latitude</Form.Label>
                                            <Form.Control
                                                id="latitude"
                                                disabled={true}
                                                value={json['latitude'] ? json['latitude'] : ''}
                                                defaultValue={json['latitude'] ? json['latitude'] : ''}
                                                onChange={(e: any) => this.formEvent.onChange("double", e.target)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" className="bottom10">
                                            <Form.Label>Longitude</Form.Label>
                                            <Form.Control
                                                id="longitude"
                                                disabled={true}
                                                value={json['longitude'] ? json['longitude'] : ''}
                                                defaultValue={json['longitude'] ? json['longitude'] : ''}
                                                onChange={(e: any) => this.formEvent.onChange("double", e.target)}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" className="bottom10">
                                            <Form.Label className="isRequired">Camada</Form.Label>
                                            <Select
                                                id="scamada"
                                                value={this.formEvent.onValueSelect('select', 'scamada', this.state.layers)}
                                                onChange={(e: any) => this.formEvent.onChange("select", e, "scamada")}
                                                closeMenuOnSelect={true}
                                                placeholder={"Selecione"}
                                                options={this.state.layers}
                                                isMulti={false}
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs="12" className="bottom10">
                                            <Form.Label className="isRequired">Tipo</Form.Label>
                                            <Select
                                                id="tipo"
                                                value={this.formEvent.onValueSelect('select', 'tipo', this.state.pointType)}
                                                onChange={(e: any) => this.formEvent.onChange("select", e, "tipo")}
                                                closeMenuOnSelect={true}
                                                placeholder={"Selecione"}
                                                options={this.state.pointType}
                                                isMulti={false}
                                            />
                                        </Col>
                                    </Row>

                                    {(json['tipo'] == 'D' || json['tipo'] == 'C') &&
                                        <Row>
                                            <Col xs="12" className="bottom10">
                                                <Form.Label>Distrito</Form.Label>
                                                <Select
                                                    id="sgepdistrito"
                                                    value={this.formEvent.onValueSelect('select', 'sgepdistrito', this.state.district)}
                                                    onChange={this.onChangeDistrict}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.district}
                                                    isMulti={false}
                                                />
                                            </Col>
                                        </Row>}
                                    {(json['tipo'] == 'D' || json['tipo'] == 'C') &&
                                        <Row>
                                            <Col xs="12" className="bottom10">
                                                <Form.Label>Identificador</Form.Label>
                                                <Form.Control
                                                    id="identificador"
                                                    value={json['identificador'] ? json['identificador'] : ''}
                                                    onChange={(e: any) => this.formEvent.onChange("varchar", e.target)}
                                                />
                                            </Col>
                                        </Row>}
                                    {(json['tipo'] == 'U' || json['tipo'] == 'R') &&
                                        <Row>
                                            <Col xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Situação do Imóvel</Form.Label>
                                                <Select
                                                    id="cgepsituacoesshape"
                                                    value={this.formEvent.onValueSelect('select', 'cgepsituacoesshape', this.state.immobileSituation)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "cgepsituacoesshape")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.immobileSituation}
                                                    isMulti={false}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    {(json['tipo'] === 'D') &&
                                        <Row>
                                            <Col xs="12" className="bottom10">
                                                <Form.Label className="isRequired">Tipo de Ponto</Form.Label>
                                                <Select
                                                    id="sgeptipoponto"
                                                    value={this.formEvent.onValueSelect('select', 'sgeptipoponto', this.state.tiposPonto)}
                                                    onChange={(e: any) => this.formEvent.onChange("select", e, "sgeptipoponto")}
                                                    closeMenuOnSelect={true}
                                                    placeholder={"Selecione"}
                                                    options={this.state.tiposPonto}
                                                    isMulti={false}
                                                />
                                            </Col>
                                        </Row>
                                    }
                                    <Row>
                                        <Col xs="12" className="bottom10">
                                            <Form.Label className="isRequired">Origem</Form.Label>
                                            <Select
                                                id="origem"
                                                value={this.formEvent.onValueSelect('select', 'origem', this.state.source)}
                                                onChange={(e: any) => this.formEvent.onChange("select", e, "origem")}
                                                closeMenuOnSelect={true}
                                                placeholder={"Selecione"}
                                                options={this.state.source}
                                                isMulti={false}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                <Col lg="8" xs="12" style={{ marginBottom: 10 }}>
                                    <MapaComponente
                                        cameraPosition={{ lat: json['latitude'], lng: json['longitude'] }}
                                        height={400}
                                        isDraw={false}
                                        isCamada={false}
                                        isSearch={false}
                                        isFilter={false}
                                        isNeighborRelatory={false}
                                        setActivedNeighborRelatory={() => console.log("Não implementado")}
                                        setActivedCreateRoute={() => console.log("Não implementado")}
                                        setActivedShapeUnification={() => console.log("Não implementado")}
                                        getClickShape={() => console.log('Não implementado')}
                                        getMap={(map: any) => this.setMap(map)}
                                        startEdit={() => console.log('Não implementado')}
                                        saveEdit={() => console.log('Não implementado')}
                                        cancelEdit={() => console.log('Não implementado')}
                                        stopDraw={() => console.log('Não implementado')}
                                        exportPDF={() => console.log("Não implementado")}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col xs="12" style={{ marginTop: 20 }}>
                                    <Button className="buttonSave" type="button" onClick={(e: any) => this.save()} variant="primary">
                                        <Image className="imageSave"
                                            src={salvar} />
                                        Salvar
                                    </Button>
                                    <Button onClick={(e: any) => this.props.delegate.tapDimiss(this.props.navigation)} className="buttonCancel" variant="link">Cancelar</Button>
                                </Col>
                            </Row>
                        </Form>
                        <ToastContainer />
                    </Container>
                </div>
                <LoaderComponente show={this.state.isLoading} hide={() => this.setState({ isLoading: this.state.isLoading })} />
            </div >
        )
    }

    private setMap(map: any) {

        if (!map) {
            return;
        }

        if (this.marker) {
            map.removeLayer(this.marker);
        }

        let json = this.state.json as any
        this.marker = new Marker({ lat: parseFloat(json['latitude']), lng: parseFloat(json['longitude']) }, {
            draggable: true
        }) as Marker;

        this.marker.on('dragend', (e: any) => {
            var latlng = e.target._latlng;
            json['latitude'] = latlng.lat
            json['longitude'] = latlng.lng

            this.setState({
                json: json
            })
        });

        map.addLayer(this.marker);
    }

    private loadLayers() {
        this.props.viewModel.fetchSelectLayers().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.name, check: false })
            }

            this.setState({
                layers: array
            })
        });
    }

    private loadPointTypes() {
        this.props.viewModel.fetchPointTypes().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.value, check: false })
            }

            this.setState({
                tiposPonto: array
            })
        });
    }

    private loadImmobileSituation() {
        this.props.viewModel.fetchImmobileSituation().then((rs) => {
            var result = rs as Array<any>
            var array = Array<any>()

            for (var i = 0; i < result.length; i++) {
                var item = result[i]
                array.push({ value: item.id, label: item.value, check: false })
            }

            this.setState({
                immobileSituation: array
            })
        });
    }

    private loadPointType() {
        var array = Array<any>()
        array.push({ value: "U", label: "Imóveis Urbanos", check: false })
        array.push({ value: "R", label: "Imóveis Rurais", check: false })
        array.push({ value: "C", label: "Cemitério", check: false })
        array.push({ value: "D", label: "Diversos", check: false })

        this.setState({
            pointType: array
        })
    }

    private loadSource() {
        var array = Array<any>()
        array.push({ value: "G", label: "GeoEfficace", check: false })
        array.push({ value: "C", label: "Cliente", check: false })

        this.setState({
            source: array
        })
    }

    private loadDistrict() {
        this.addressViewModel.fetchSelectProperty().then((rs) => {
            if (!rs || rs.length === 0) return;

            const json = rs[0];
            const keys = Object.keys(json);
            const districts: Record<string, any[]> = {};

            for (const key of keys) {
                const result = json[key] as Array<any>;
                const array = result.map((item) => ({
                    value: item.id,
                    label: item.value,
                    check: false,
                }));
                districts[key] = array;
            }
            this.setState({ district: districts.gepdistrito });
        });
    }

    private setLatLng(latitude: string, longitude: string) {
        var json = this.state.json as any
        json['latitude'] = latitude
        json['longitude'] = longitude

        this.setState({
            json: json
        })
    }

    private save() {
        var json = this.state.json as any
        if (json['scamada'] == undefined || json['tipo'] == undefined || json['origem'] == undefined) {
            this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
            return
        }

        if (json['tipo'] == 'U' || json['tipo'] == 'R') {
            if (json['cgepsituacoesshape'] == undefined) {
                this.showFieldsEmpty("Campos obrigatórios não preenchidos!")
                return
            }
        }

        if (this.props.idPrimary > 0) {
            json['sshape'] = this.props.idPrimary
        }
        this.props.viewModel.fetchSalvar(json).then((rs) => {
            toast.success("Registro incluído com sucesso!", {
                position: toast.POSITION.BOTTOM_RIGHT
            });

            setTimeout(() => {
                if (json['sgeppontos']) {
                    this.props.delegate.tapDimiss(this.props.navigation);
                } else {
                    this.props.delegate.tapProperty(this.props.navigation, rs[0].sgeppontos, json['tipo']);
                }
            }, 1000);
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        })
    }

    private showFieldsEmpty(message: string) {
        toast.error(message, {
            position: toast.POSITION.BOTTOM_RIGHT
        });
    }

    private loadStruct() {
        var json = this.state.json as any
        json['sshape'] = this.props.idPrimary

        this.props.viewModel.fetchDataOne(json).then((rs) => {
            var resultado = rs as Array<any>
            if (resultado.length > 0) {
                var resultJSON = resultado[0]
                var geom = JSON.parse(resultJSON['geom'])
                resultJSON['latitude'] = geom['coordinates'][1]
                resultJSON['longitude'] = geom['coordinates'][0]

                delete resultJSON['geom']
                this.setState({
                    isLoading: false,
                    json: resultado[0]
                })

                return
            }

            this.setState({ isLoading: false })
        }, e => {
            toast.error(JSON.stringify(e), {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        });
    }
    private onChangeDistrict = async (e: any) => {
        this.formEvent.onChange("select", e, "sgepdistrito");
        const json = this.state.json as any
        const response = await this.addressViewModel.loadAcronymByDistrict(e.value)
        if (json['identificador']) {
            if (response.identificador) {
                json['identificador'] = response.identificador
            } else {
                json['identificador'] = ''
            }
        } else {
            json['identificador'] = response.identificador
        }
        this.setState({
            prefix: response.sigla,
            json
        });
    };
}